import { TCreateWorkflowTemplateLinkParams } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const createWorkflowTemplateLink = async (
  data: TCreateWorkflowTemplateLinkParams
): Promise<{
  success: boolean;
  data?: { workflowTemplateLink: { id: string } };
  error?: string;
}> => {
  try {
    const res = await fetcher(`${BASE_URL}/links`, {
      method: 'POST',
      body: data,
    });
    if (!res.ok) {
      const errorBody = (await res.json()) as { message?: string } | null;
      return { success: false, data: undefined, error: errorBody?.message };
    }
    const responseData = (await res.json()) as {
      workflowTemplateLink: { id: string };
    };
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error(err);
    return { success: false, data: undefined };
  }
};
